<template>
  <div class="wfh-modal-mask">
    <div class="wfh-modal-wrapper">
      <div class="wfh-modal-content">
        <div class="row">
          <button type="button" @click="closeModal" class="modal-close-btn">
            X
          </button>
        </div>

        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    closeModal () {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.wfh-modal-content {
  max-width: 75vw;
}
</style>
